module.exports = __webpack_public_path__ + "img/Panel.2d259fcc.png";